import { axiosInstance } from "./axios";
import { IError } from "dto/IError";
import useCustomMutation from "hooks/useCustomMutation";
import useCustomQuery from "hooks/useCustomQuery";
import { IChatMessage } from "dto/Chat/IChatMessage";
import { IChat } from "dto/Chat/IChat";

const queryKeys = {
  getChat: () => "chatService.getChat",
};

export interface Attachment {
  KeyId?: string;
  Order: number;
  Uri: string;
}

export interface ISendMessage {
  ChatId: string;
  Content: string;
  Attachments: Attachment[];
}

export interface IChatParticipant {
  UserId: string;
}

export interface ICreateChat {
  Name: string | null;
  Participants: IChatParticipant[];

  PublicKey?: string;
  PrivateKey?: string;
}

export interface IUpdateChat {
  ChatId: string;
  Name?: string;
  Participants?: IChatParticipant[];
  PublicKey?: string;
  PrivateKey?: string;
}

const createChat = (payload: ICreateChat): Promise<{ data: IChat }> => {
  return axiosInstance.post("/chat", payload);
};

const useCreateChat = () => {
  return useCustomMutation(createChat);
};

const updateChat = (payload: IUpdateChat): Promise<{ data: IChat }> => {
  return axiosInstance.put("/chat", payload);
};

const useUpdateChat = () => {
  return useCustomMutation(updateChat);
};

const sendMessage = (
  payload: ISendMessage
): Promise<{ data: IChatMessage }> => {
  return axiosInstance.post("/chat/message", payload);
};

const useSendMessage = () => {
  return useCustomMutation(sendMessage);
};

const getChat = (id: string): Promise<{ data: IChat }> => {
  return axiosInstance.get(`chat?id=${id}`);
};

const useGetChat = (id: string) => {
  return useCustomQuery(queryKeys.getChat(id), () => getChat(id));
};

const leave = (id: string): Promise<{ data: IError }> => {
  return axiosInstance.post(`/chat/leave?id=${id}`);
};

const useLeave = () => {
  return useCustomMutation(leave);
};

const deleteChat = (id: string): Promise<{ data: IError }> => {
  return axiosInstance.delete(`/chat?id=${id}`);
};

const useDeleteChat = () => {
  return useCustomMutation(deleteChat);
};

const deleteMessage = (id: string): Promise<{ data: IError }> => {
  return axiosInstance.delete(`/chat/message?id=${id}`);
};

const useDeleteMessage = () => {
  return useCustomMutation(deleteMessage);
};

const getChatAsync = () => {
  return useCustomMutation(getChat);
};

export default {
  useSendMessage,
  useGetChat,
  useCreateChat,
  useUpdateChat,
  useDeleteChat,
  useDeleteMessage,
  useLeave,
  getChatAsync,
};
